import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import './index.less';
import './themes/default.less';
import Quest from "../Quest";
export default class InputTooltip extends MainComponent {
    static propTypes = {
        itemStyle: PropTypes.string,
        mainStyle: PropTypes.string,
        inputStyle: PropTypes.string,
        type: PropTypes.string,
        placeHolder: PropTypes.string,
        label: PropTypes.string,
        tooltip: PropTypes.string,
        caption: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        iconLeft: PropTypes.element,
        iconRight: PropTypes.element,
        onChange: PropTypes.func,
        onEnter: PropTypes.func,
        onArrowDown: PropTypes.func,
        onArrowUp: PropTypes.func,
        onEscape: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        useBgStyle: PropTypes.bool,
        required: PropTypes.bool,
        inputProps: PropTypes.object,
        validator: PropTypes.func,
    };
    static defaultProps = {
        itemStyle: "",
        mainStyle: "",
        inputStyle: "text p1",
        type: "text",
        placeHolder: "",
        label: "",
        tooltip: "",
        caption: "components.inputCaption",
        value: null,
        iconLeft: null,
        iconRight: null,
        onChange: null,
        onEnter: null,
        onArrowDown: null,
        onArrowUp: null,
        onEscape: null,
        onFocus: null,
        onBlur: null,
        useBgStyle: true,
        required: false,
        inputProps: {},
        validator: null,
    };

    constructor(props) {
        super(props);

        this.inhProps = {};
    }

    componentDidMount() {
        if (this.propsAll.value !== null)
            this.value = this.propsAll.value;
    }
    componentDidUpdate() {
        if (this.propsAll.value !== null)
            this.value = this.propsAll.value;
    }

    get value() {
        return this.input.value;
    }

    set value(value) {
        return this.input.value = value;
    }

    get propsAll() {
        return { ...this.props, ...this.inhProps };
    }

    validate() {
        if (!this.propsAll.required)
            return true;

        this.wasValidateCall = true;

        const value = this.value;
        if (value) {
            this._helper.dom.removeClass(this.inputItem, "unvalid");
            return value;
        }

        this._helper.dom.addClass(this.inputItem, "unvalid");
        return false;
    }

    validateCb(cb) {
        if (cb(this.value)) {
            return this._helper.dom.removeClass(this.inputItem, "unvalid");
        }

        return this._helper.dom.addClass(this.inputItem, "unvalid");
    }

    onSelfClick() {
        if (document.activeElement === this.input)
            return;

        this.input.focus();

        if (this.propsAll.type === "text") {
            const tm = setTimeout(() => {
                clearTimeout(tm);
                this.input.selectionStart = this.input.selectionEnd = 10000;
            }, 10);
        }
    }

    _onClick(onClick, e) {
        this._helper.stopEvent(e);

        if (onClick?.apply)
            onClick(e, this.input);
    }

    _onFocus(e) {
        this._helper.stopEvent(e);

        if (this.propsAll.onFocus?.apply)
            this.propsAll.onFocus(this.input);
    }

    _onBlur() {
        this._helper.dom.removeClass(this.inputCont, "focused");

        if (this.propsAll.type === "number" && !this.value) {
            this.value = 0;
            this.onChange();
        }

        if (this.propsAll.onBlur?.apply)
            this.propsAll.onBlur(this.input);
    }

    onKeyUp(e) {
        const { required, onEnter, onArrowDown, onArrowUp, onEscape } = this.propsAll;

        this.checkValidator();

        if (required && this.wasValidateCall)
            this.validate();

        if (e.key === "Enter") {
            this.input.blur();

            if (onEnter?.apply)
                onEnter();
        }

        if (e.key === "ArrowDown") {
            if (onArrowDown?.apply)
                onArrowDown();
        }

        if (e.key === "ArrowUp") {
            if (onArrowUp?.apply)
                onArrowUp();
        }

        if (e.keyCode === 27) {
            if (onEscape?.apply)
                onEscape();
        }
    }

    formatValue() {
        const value = this.value;
        if (this.propsAll.type === "number" && this.value)
            return parseFloat(this.value);

        return value;
    }

    checkValidator() {
        const { validator } = this.propsAll;
        if (!validator?.apply)
            return;

        const value = validator(this.value, this.propsAll);
        if (value !== this.value)
            this.value = value;
    }

    onChange() {
        const { onChange } = this.propsAll;

        this.checkValidator();

        if (onChange?.apply)
            onChange(this.formatValue(), this.input);
    }

    getLeftIcon(iconLeft) {
        return iconLeft;
    }

    setFocus() {
        this.input.focus();
    }

    render() {
        const { itemStyle, mainStyle, inputStyle, type, label, tooltip, caption, placeHolder, iconLeft, iconRight,
            useBgStyle, required, inputProps, accept, readonly, onClick } = this.propsAll;
        const placeholder = placeHolder ? this.tr(placeHolder) : "";
        const bgStyle = useBgStyle ? "" : "withoutBg";
        const reqSt = required ? "required" : "";

        const leftIcon = this.getLeftIcon(iconLeft);

        return (
            <div ref={el => this.inputItem = el} className={`inputItem ${itemStyle} ${reqSt}`}>
                {!!label && (
                    <div className="flex centerV between">
                        <div className="inputLabel text p2">{this.tr(label)}</div>
                        {!!tooltip && <Quest textTooltip={this.tr(tooltip)} size={14} />}
                    </div>

                )}
                <div
                    ref={el => this.inputCont = el}
                    className={`inputCont flex centerV rad4 ${mainStyle} ${bgStyle}`}
                    onClick={this.onSelfClick.bind(this)}
                >
                    {!!leftIcon && leftIcon}
                    <input
                        ref={el => this.input = el}
                        type={type}
                        className={`input flex1 ${inputStyle}`}
                        placeholder={placeholder}
                        spellCheck={false}
                        autoComplete="off"
                        accept={accept}
                        readOnly={readonly}
                        onClick={this._onClick.bind(this, onClick)}
                        onFocus={this._onFocus.bind(this)}
                        onBlur={this._onBlur.bind(this)}
                        onKeyUp={this.onKeyUp.bind(this)}
                        onChange={this.onChange.bind(this)}
                        {...inputProps}
                    />
                    {!!iconRight && iconRight}
                </div>
                {caption && <div ref={el => this.inputCaption = el} className="inputCaption text p2">{this.tr(caption)}</div>}
            </div>
        );
    }
}
